import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { landingServices } from "src/app/landing/Services/landing.service";
import { StorageService } from "src/app/shared/Services/storage.service";
import { JwtService } from "src/app/shared/Services/jwt.service";
import { MatMenuTrigger } from '@angular/material/menu';
import { LoaderService } from "src/app/shared/Services/loader.service";
import { LayoutService } from "src/app/shared/Services/layout.service";
import { SharedService } from "src/app/shared/Services/shared.service";
import { homeServices } from "src/app/home/Services/home.service";
import { Subscription } from "rxjs";
import { BaseComponent } from "src/app/shared/Components/base/base.component";
import { EventBusService } from "src/app/shared/Services/event-bus-service.service";
import { environment } from "src/environments/environment";
import { Constant } from "src/app/shared/Constants/constant";
import { TokenService } from "src/app/shared/Services/token.service";
import { UserType } from "src/app/shared/Constants/user-type";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
//@Injectable()
export class HeaderComponent extends BaseComponent implements OnInit {
  HeaderData!: import("src/app/landing/Models/header-menu-model").HeaderMenuModel[];
  private headerDataSubscription!: Subscription;
 selectedClientId!: any;
 selectedSClientId!: any;
  CurrentRoute!: string;
  preLoader:boolean=false;
  UserName!: string;
  UserType!: string;
  ImgPath!: string;
  ReceivedData: any;
  IsLogin: boolean;
  Islstopen: boolean = false;
  selectedClientName!: string;
  IsCollapsed: boolean = true;
  IsCollapsedMenu: boolean = false;
  LoginTypeSelect: any = "Login";
  UserDetails!: {};
  UserDataShow: boolean = false;
  LinkActive: any = "dashboard";
  OpenMenu: boolean = false;
  logoPath !: string;
  ClientType!:string;
  ConstantClient!:string;
  uType:any;
  constructor(
    private router: Router,
    private landingServices: landingServices,
    public storageService: StorageService,
    private jwtService: JwtService,
    private FSloaderService: LoaderService,
    private layoutService: LayoutService,
    private eventBus: EventBusService,
    private sharedService : SharedService,private homeService:homeServices,private elementRef: ElementRef,private tokenService: TokenService
  ) {super();
    this.uType = UserType;
    this.sharedService.selectedClientId$.subscribe(clientId => {
      this.selectedClientId = clientId??localStorage.getItem('selectedClientId');
    });
    this.sharedService.selectedSClientId$.subscribe(sclientId => {
      this.selectedSClientId =localStorage.getItem('supplierClientId');
    });
    
    this.sharedService.selectedClientName$.subscribe(clientName => {
      this.selectedClientName = clientName != '' ? clientName : localStorage.getItem('selectedClientName')??'';
    });
    this.IsLogin = this.storageService.isLoggedIn();
    if(this.IsLogin){
      this.tokenService.isTokenExpire();
    }
    //this.loginStatus();
    this.getLoginDetail();
    this.logoPath = environment.ClientLogo;
    this.ClientType = environment.ClientName;
    this.ConstantClient = Constant.Virtusa;
  }

  // async loginStatus(){
  //   const url = await this.storageService.GetUrl();
  //   if (!Constant.ROUTE_HEADINGS.some(async route => (await url).includes(route))) {
  //     this.IsLogin = this.storageService.isLoggedIn();
  //   }
  //   else
  //   {
  //     this.IsLogin = false;
  //   }
  // }
  toggleMenu() {
    this.OpenMenu = !this.OpenMenu;
  }

  async loadHeaderData(): Promise<void> {
    (await this.landingServices.getHeaderData()).subscribe((data) => {
      this.HeaderData = data;
    });
  }

  OpenlfMenu() {
    this.Islstopen = !this.Islstopen;
  }
  
  showLoginButton = true;
  showRegisterLink = true;
  override ngOnInit() {
    this.layoutService.showLoginButton$.subscribe((show: boolean) => {
      this.showLoginButton = show;
    });
    this.layoutService.showRegisterButton$.subscribe((show: boolean) => {
      this.showRegisterLink = show;
    });

    this.loadHeaderData();
    if (this.IsLogin) this.getLoginDetail();
    this.eventBus.logout$.subscribe(() => this.logout());
  }

  toggleCollapse() {
    this.IsCollapsed = !this.IsCollapsed;
  }

  toggleCollapseMenu() {
    this.IsCollapsedMenu = !this.IsCollapsedMenu;
  }

  selectLoginType = (val: any) => {
    this.IsCollapsed = !this.IsCollapsed;
    const lowercaseVal = val.toLowerCase();
    this.LoginTypeSelect = val;
    this.router.navigate(["auth/login/", lowercaseVal]);
  };

  logout() {
    this.FSloaderService.showLoader();
    this.storageService.clean();
    this.storageService.removeLocalStorage();
    this.tokenService.stopTokenRefreshTimer();
    this.UserDetails = {};
    this.router.navigate(["/home"]).then(() => {
      window.location.reload();
      window.scrollTo(0, 0);
    });
    this.loadHeaderData();
    this.IsLogin = false;
  }
  
  
  getLoginDetail() {
    if (this.storageService.isLoggedIn()) {
      this.UserName = this.jwtService.getUserName();
      this.UserType = this.jwtService.getUserType();
      this.ImgPath = this.jwtService.getImagePath();
    }
    this.UserDataShow = true;
  }

  activeLinks(val: any) {
    this.LinkActive = val;
    this.UserDataShow = true;
  }

  redirectToProfile(){
    
    this.router.navigate(["/supplier/detail"]);
    this.OpenMenu = false;
  }

  redirectToChangePassword(){
    this.router.navigate(["/user/changepassword"]);
    this.OpenMenu = false;
  }

  exitClientMode() {
    this.selectedClientId = 0;
    this.sharedService.setSelectedClientId(this.selectedClientId);
    this.storageService.removeLocalStorage();
    this.router.navigate(['/enterprise/index']);
  }
  exitSClientMode() {
    this.selectedSClientId=0;
    this.sharedService.setsupplierSelectedClientId(this.selectedClientId);
    this.storageService.removeLocalStorage();
    this.router.navigate(['/dashboard']);
  }

  redirectTo(url : any){
    this.router.navigate([url]);
    // this.router.navigate([url]).then(() => {
    //   window.location.reload();
    // });
  }

  @HostListener('document:click', ['$event'])
  public onClick(event: Event) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (this.OpenMenu && !clickedInside) {
      this.OpenMenu = false;
  }
}
}
